import React, { useState } from 'react';
import {
  Container,
  Typography,
  Box,
  Tabs,
  Tab,
  Paper
} from '@mui/material';
import {
  People as PeopleIcon,
  RecordVoiceOver as VoiceIcon,
  Category as CategoryIcon,
  LocalHospital as SpecialtyIcon
} from '@mui/icons-material';
import CharacterManager from './CharacterManager';
import PresetManager from './PresetManager';
import VoiceManager from './VoiceManager';
import { getCurrentUser } from '../../services/auth';
import { isGlobalAdmin } from '../../utils/role';

function TabPanel({ children, value, index, ...other }) {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`platform-tabpanel-${index}`}
      aria-labelledby={`platform-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
}

const PlatformSettings = () => {
  const [activeTab, setActiveTab] = useState(0);
  const user = getCurrentUser();

  // Only allow admins to access this
  if (!isGlobalAdmin(user)) {
    return (
      <Container sx={{ py: 4 }}>
        <Typography variant="h4" color="error">
          Access Denied
        </Typography>
        <Typography>
          You need administrator privileges to access platform settings.
        </Typography>
      </Container>
    );
  }

  const handleTabChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Platform Settings
      </Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        Manage platform-wide characters, presenting complaints, specialties, and voice models available to all tenants.
      </Typography>

      <Paper sx={{ width: '100%' }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Tabs value={activeTab} onChange={handleTabChange} aria-label="platform settings tabs">
            <Tab 
              icon={<PeopleIcon />} 
              label="Characters" 
              id="platform-tab-0"
              aria-controls="platform-tabpanel-0"
            />
            <Tab 
              icon={<CategoryIcon />} 
              label="Presenting Complaints" 
              id="platform-tab-1"
              aria-controls="platform-tabpanel-1"
            />
            <Tab 
              icon={<SpecialtyIcon />} 
              label="Specialties" 
              id="platform-tab-2"
              aria-controls="platform-tabpanel-2"
            />
            <Tab
              icon={<VoiceIcon />}
              label="Voice Models"
              id="platform-tab-3"
              aria-controls="platform-tabpanel-3"
            />
          </Tabs>
        </Box>

        <TabPanel value={activeTab} index={0}>
          <CharacterManager />
        </TabPanel>

        <TabPanel value={activeTab} index={1}>
          <PresetManager type="presenting-complaints" title="Presenting Complaints" />
        </TabPanel>

        <TabPanel value={activeTab} index={2}>
          <PresetManager type="specialties" title="Specialties" />
        </TabPanel>

        <TabPanel value={activeTab} index={3}>
          <VoiceManager />
        </TabPanel>
      </Paper>
    </Container>
  );
};

export default PlatformSettings;